var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadsInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2122_22194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9736 13.357C19.8802 13.0082 19.5216 12.8012 19.1731 12.8948L18.1822 13.1603L16.6596 7.47781C16.5662 7.12953 16.2077 6.92207 15.859 7.01562L13.9648 7.5232L12.7806 3.10344C12.6872 2.75496 12.3285 2.54769 11.9801 2.64125L6.92895 3.99469C6.58051 4.08804 6.37328 4.44656 6.46676 4.79523C6.54707 5.09496 8.84395 13.667 8.92391 13.9654C8.70774 13.9073 8.48082 13.8759 8.2466 13.8759C7.98055 13.8759 7.72375 13.9161 7.48168 13.9903L4.77653 3.89472C4.49602 2.84785 3.42199 2.22762 2.37489 2.50808L0.480706 3.01562C0.131995 3.10906 -0.0748804 3.4675 0.0185181 3.81617C0.111956 4.16484 0.470276 4.37191 0.819065 4.27836L2.71324 3.77082C3.06215 3.67726 3.42028 3.88402 3.51379 4.23305L6.32399 14.7208C5.89469 15.1868 5.63196 15.8085 5.63196 16.4905C5.63196 17.9323 6.80489 19.1052 8.24657 19.1052C9.68828 19.1052 10.8612 17.9322 10.8612 16.4905C10.8612 16.4855 10.8608 16.4805 10.8608 16.4754L19.5114 14.1575C19.8601 14.0641 20.0671 13.7057 19.9736 13.357ZM8.91379 8.8766L7.89871 5.08828L11.687 4.0732L12.7021 7.86152L8.91379 8.8766ZM8.24657 17.7978C7.52571 17.7978 6.93926 17.2114 6.93926 16.4905C6.93926 15.7697 7.52571 15.1832 8.24657 15.1832C8.96743 15.1832 9.55387 15.7697 9.55387 16.4905C9.55387 17.2114 8.96743 17.7978 8.24657 17.7978ZM10.6056 15.1904L9.25215 10.1393C9.54258 10.0615 15.1336 8.5634 15.566 8.44754L16.9193 13.4986L10.6056 15.1904Z",
    fill: "#757575"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2122_22194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.772705)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadsInactive);
export default __webpack_public_path__ + "static/media/loads-inactive.2a4e329c001927b11027ecfd9c413439.svg";
export { ForwardRef as ReactComponent };